// import React, { useState, useEffect, useRef, useMemo } from "react";
// import { TemplateHeader, TemplateFooter } from "../Preview/SharedTemplateComponents"; 
// import { normalizeFieldOrder } from "../letter/utlis/normalizeFieldOrder";

// const A4_WIDTH_PX = 794;
// const A4_HEIGHT_PX = 1122;

// const normalizeColor = (color) => {
//   if (!color || !color.trim()) return "#ffffff";
//   return color;
// };

// const isLightColor = (color) => {
//   if (!color || color === "#ffffff") return true;
//   const hex = color.replace("#", "");
//   const r = parseInt(hex.substring(0, 2), 16), g = parseInt(hex.substring(2, 4), 16), b = parseInt(hex.substring(4, 6), 16);
//   return (r * 299 + g * 587 + b * 114) / 1000 > 200;
// };

// export default function PreviewCard({ state: templateState }) {
//   const containerRef = useRef(null);
//   const [scale, setScale] = useState(1);

//   useEffect(() => {
//       const handleResize = () => {
//           if (containerRef.current) {
//               const parentWidth = containerRef.current.offsetWidth;
//               const availableWidth = parentWidth - 48; 
//               const newScale = Math.min(availableWidth / A4_WIDTH_PX, 1);
//               setScale(newScale > 0 ? newScale : 1);
//           }
//       };
//       handleResize();
//       window.addEventListener('resize', handleResize);
//       return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const logoSrc = useMemo(() => {
//     if (templateState.logoFile) return URL.createObjectURL(templateState.logoFile);
//     if (templateState.logoUrl) return templateState.logoUrl;
//     return null;
//   }, [templateState.logoFile, templateState.logoUrl]);

//   if (!templateState) return <div className="text-center p-4">Loading Preview...</div>;

//   const headerBg = normalizeColor(templateState.headerColor);
//   const footerBg = normalizeColor(templateState.footerColor);
//   const headerTextClass = isLightColor(headerBg) ? "text-dark" : "text-white";
//   const footerTextClass = isLightColor(footerBg) ? "text-dark" : "text-white";

//   const logoSizeStyle = { 
//     small: { height: "3rem" }, 
//     medium: { height: "4rem" }, 
//     large: { height: "6rem" } 
//   }[templateState.logoSize] || { height: "4rem" };

//   const headerLayout = templateState.headerLayout || "stacked";
//   const logoAlign = templateState.logoAlignment || "left";
//   const textAlign = templateState.textAlignment || "left";
//   const isStacked = headerLayout === "stacked";
//   const isLogoLeft = headerLayout === "logo-left";

//   const textStyles = { 
//     left: { alignItems: "flex-start", textAlign: "left" }, 
//     center: { alignItems: "center", textAlign: "center" }, 
//     right: { alignItems: "flex-end", textAlign: "right" } 
//   }[textAlign] || { alignItems: "flex-start", textAlign: "left" };

//   const logoWrapperStyles = isStacked ? { 
//     left: { justifyContent: "flex-start" }, 
//     center: { justifyContent: "center" }, 
//     right: { justifyContent: "flex-end" } 
//   }[logoAlign] || { justifyContent: "flex-start" } : {};

//   // ====================================================================
//   //  DYNAMIC ORDERING ENGINE FOR PREVIEW
//   // ====================================================================
//   const getFieldValue = (key) => {
//     if (key === "name") return templateState.companyName;
//     if (key === "email") return templateState.companyEmail;
//     if (key === "phone") return templateState.companyPhone;
//     if (key === "address") return templateState.companyAddress;
//     if (key === "cin") return templateState.cin;
//     if (key === "gst") return templateState.gst;
//     const custom = templateState.customFields?.find(f => f.key === key);
//     return custom ? custom.value : "";
//   };

//   // 1. Process Footer Ordering
//   const baseFooterKeys = ["name", "email", "phone", "address", "cin", "gst", ...(templateState.customFields?.map(f => f.key) || [])];
//   const footerOrder = normalizeFieldOrder(templateState.footerFieldOrder, baseFooterKeys);

//   const footerFieldsMap = footerOrder.map(key => {
//     const val = getFieldValue(key);
//     let label = key === "name" ? "Company" : key === "cin" ? "CIN" : key === "gst" ? "GST Number" : key.charAt(0).toUpperCase() + key.slice(1);
//     const custom = templateState.customFields?.find(f => f.key === key);
//     if (custom) label = key;
//     return { key, label, value: val, isVisible: !!templateState.showFooterFields?.[key] };
//   });

//   // 2. Process Header Ordering
//   const baseHeaderKeys = ["name", "email", "phone", "address", ...(templateState.customFields?.map(f => f.key) || [])];
//   const headerOrder = normalizeFieldOrder(templateState.headerFieldOrder, baseHeaderKeys);

//   const headerFieldsMap = headerOrder.map(key => {
//     const val = getFieldValue(key);
//     let label = key === "name" ? "Company" : key.charAt(0).toUpperCase() + key.slice(1);
//     const custom = templateState.customFields?.find(f => f.key === key);
//     if (custom) label = key;
//     return { key, label, value: val, isVisible: !!templateState.showCompanyFields?.[key] };
//   });
//   // ====================================================================

//   return (
//     <div 
//       ref={containerRef} 
//       className="w-100 d-flex flex-column align-items-center"
//       style={{ 
//         backgroundColor: "#e9ecef", 
//         // padding: "1.5rem", 
//         overflowX: "hidden", 
//         borderRadius: "0.75rem", 
//         border: "1px solid #dee2e6",
//         boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center w-100  flex-shrink-0">
//         <h3 className="h5 fw-bold text-dark mb-0">Preview</h3>
//       </div>

//       <div className="single-page-wrapper z-10 d-flex flex-column" style={{ transformOrigin: "top" }}>
//         <div 
//             className="single-page bg-white shadow-lg mx-auto position-relative d-flex flex-column overflow-hidden"
//             style={{ 
//                 width: `${A4_WIDTH_PX}px`, 
//                 height: `${A4_HEIGHT_PX}px`, 
//                 minWidth: `${A4_WIDTH_PX}px`, 
//                 minHeight: `${A4_HEIGHT_PX}px`, 
//                 transform: `scale(${scale})`, 
//                 marginBottom: `${-(A4_HEIGHT_PX * (1 - scale))}px`,
//                 boxShadow: "0 1rem 3rem rgba(0,0,0,0.175)"
//             }}
//         >
//             <TemplateHeader 
//                 isPdfMode={true}
//                 headerBg={headerBg}
//                 showHeaderBg={templateState.showHeaderBg}
//                 textColorClass={headerTextClass}
//                 subTextColorClass={headerTextClass}
//                 isStacked={isStacked}
//                 isLogoLeft={isLogoLeft}
//                 logoWrapperClasses={logoWrapperStyles}
//                 textClasses={textStyles}
//                 textAlign={textAlign}
//                 logoSrc={logoSrc}
//                 logoSizeClass={logoSizeStyle}
//                 showCompanyInfo={templateState.showCompanyInfo}
//                 headerFields={headerFieldsMap} 
//             />

//             <div 
//               className="flex-grow-1 d-flex flex-column overflow-hidden"
//               style={{ 
//                 paddingLeft: "4rem", 
//                 paddingRight: "4rem", 
//                 paddingTop: "2rem", 
//                 paddingBottom: "2rem",
//                 color: "#0f172a",
//                 fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
//                 fontSize: "12pt",
//                 lineHeight: "1.6"
//               }}
//             >
//                 <div className="flex-grow-1" style={{ textAlign: "left", whiteSpace: "pre-wrap" }}>
//                     <div style={{ marginBottom: "2rem" }}>
//                         <p style={{ marginBottom: "1.5rem", color: "#4b5563", fontWeight: "500" }}>[Date]</p>
//                         <div style={{ marginBottom: "1.5rem" }}>
//                             <h4 style={{ fontWeight: "bold", fontSize: "13pt", color: "#0f172a", marginBottom: "0.25rem", textTransform: "uppercase" }}>Recipient Name</h4>
//                             <div style={{ color: "#4b5563", whiteSpace: "pre-line", lineHeight: "1.4" }}>Designation<br/>Company Name</div>
//                         </div>
//                         <p style={{ marginTop: "1.5rem", color: "#0f172a", fontWeight: "500" }}>Dear [Name],</p>
//                     </div>

//                     <div style={{ textAlign: "justify" }}>
//                         <p style={{ marginBottom: "0.5rem" }}>This is a preview of your letterhead template. The logo and company details above will appear on every document created with this template.</p>
//                         <p style={{ marginBottom: "0.5rem" }}>You can adjust the colors, logo size, and alignment using the controls on the left.</p>
//                     </div>

//                     <div style={{ marginTop: "2rem", marginBottom: "1rem", breakInside: "avoid" }}>
//                         <p style={{ marginBottom: "1rem", color: "#0f172a", fontWeight: "500" }}>Sincerely,</p>
//                         <div style={{ marginTop: "2rem" }}>
//                             <p style={{ fontWeight: "bold", color: "#0f172a", fontSize: "12pt", letterSpacing: "0.05em", textTransform: "uppercase", marginBottom: 0 }}>[Your Name]</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <TemplateFooter 
//                 isPdfMode={true}
//                 footerBg={footerBg}
//                 footerTextClass={footerTextClass}
//                 footerText={templateState.footerText}
//                 showCompanyInfoFooter={templateState.showCompanyInfoFooter}
//                 footerFields={footerFieldsMap} 
//                 iqCode={templateState.iqCode}
//                 subject={templateState.subject}
//             />
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef, useMemo } from "react";
import { TemplateHeader, TemplateFooter } from "../Preview/SharedTemplateComponents";
import { normalizeFieldOrder } from "../letter/utlis/normalizeFieldOrder";

const A4_WIDTH_PX = 794;
const A4_HEIGHT_PX = 1122;

const normalizeColor = (color) => {
  if (!color || !color.trim()) return "#ffffff";
  return color;
};

const isLightColor = (color) => {
  if (!color || color === "#ffffff") return true;
  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16),
    g = parseInt(hex.substring(2, 4), 16),
    b = parseInt(hex.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 200;
};

export default function PreviewCard({ state: templateState }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const parentWidth = containerRef.current.offsetWidth;
        const availableWidth = parentWidth - 48;
        const newScale = Math.min(availableWidth / A4_WIDTH_PX, 1);
        setScale(newScale > 0 ? newScale : 1);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const logoSrc = useMemo(() => {
    if (templateState.logoFile) return URL.createObjectURL(templateState.logoFile);
    if (templateState.logoUrl) return templateState.logoUrl;
    return null;
  }, [templateState.logoFile, templateState.logoUrl]);

  if (!templateState) return <div className="text-center p-4">Loading Preview...</div>;

  const headerBg = normalizeColor(templateState.headerColor);
  const footerBg = normalizeColor(templateState.footerColor);
  const headerTextClass = isLightColor(headerBg) ? "text-dark" : "text-white";
  const footerTextClass = isLightColor(footerBg) ? "text-dark" : "text-white";

  // const logoSizeStyle = { 
  //   small: { height: "3rem" }, 
  //   medium: { height: "4rem" }, 
  //   large: { height: "6rem" } 
  // }[templateState.logoSize] || { height: "4rem" };

  const logoSize = `${templateState.logoSize || 80}px`;

  const headerLayout = templateState.headerLayout || "stacked";
  const logoAlign = templateState.logoAlignment || "left";
  const textAlign = templateState.textAlignment || "left";
  const isStacked = headerLayout === "stacked";
  const isLogoLeft = headerLayout === "logo-left";

  const textStyles = {
    left: { alignItems: "flex-start", textAlign: "left" },
    center: { alignItems: "center", textAlign: "center" },
    right: { alignItems: "flex-end", textAlign: "right" }
  }[textAlign] || { alignItems: "flex-start", textAlign: "left" };

  const logoWrapperStyles = isStacked ? {
    left: { justifyContent: "flex-start" },
    center: { justifyContent: "center" },
    right: { justifyContent: "flex-end" }
  }[logoAlign] || { justifyContent: "flex-start" } : {};

  // ====================================================================
  //  DYNAMIC ORDERING ENGINE FOR PREVIEW
  // ====================================================================
  const getFieldValue = (key) => {
    if (key === "name") return templateState.companyName;
    if (key === "email") return templateState.companyEmail;
    if (key === "phone") return templateState.companyPhone;
    if (key === "address") return templateState.companyAddress;
    if (key === "cin") return templateState.cin;
    if (key === "gst") return templateState.gst;
    const custom = templateState.customFields?.find(f => f.key === key);
    return custom ? custom.value : "";
  };

  // 1. Process Footer Ordering
  const baseFooterKeys = ["name", "email", "phone", "address", "cin", "gst", ...(templateState.customFields?.map(f => f.key) || [])];
  const footerOrder = normalizeFieldOrder(templateState.footerFieldOrder, baseFooterKeys);

  const footerFieldsMap = footerOrder.map(key => {
    const val = getFieldValue(key);
    let label = key === "name" ? "Company" : key === "cin" ? "CIN" : key === "gst" ? "GST Number" : key.charAt(0).toUpperCase() + key.slice(1);
    const custom = templateState.customFields?.find(f => f.key === key);
    if (custom) label = key;
    return { key, label, value: val, isVisible: !!templateState.showFooterFields?.[key] };
  });

  // 2. Process Header Ordering
  const baseHeaderKeys = ["name", "email", "phone", "address", ...(templateState.customFields?.map(f => f.key) || [])];
  const headerOrder = normalizeFieldOrder(templateState.headerFieldOrder, baseHeaderKeys);

  const headerFieldsMap = headerOrder.map(key => {
    const val = getFieldValue(key);
    let label = key === "name" ? "Company" : key.charAt(0).toUpperCase() + key.slice(1);
    const custom = templateState.customFields?.find(f => f.key === key);
    if (custom) label = key;
    return { key, label, value: val, isVisible: !!templateState.showCompanyFields?.[key] };
  });
  // ====================================================================

  return (
    <div
      ref={containerRef}
      className="w-100 d-flex flex-column align-items-center"
      style={{
        backgroundColor: "#e9ecef",
        padding: "1rem",
        overflow: "hidden",
        borderRadius: "0.75rem",
        border: "1px solid #dee2e6",
        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
        minHeight: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <div className="d-flex justify-content-between align-items-center w-100 flex-shrink-0" style={{ marginBottom: "1rem" }}>
        <h3 className="h5 fw-bold text-dark mb-0">Preview</h3>
      </div>

      {/* Center the page wrapper */}
      <div
        className="single-page-wrapper z-10"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <div
          className="single-page bg-white shadow-lg position-relative d-flex flex-column overflow-hidden"
          style={{
            width: `${A4_WIDTH_PX}px`,
            height: `${A4_HEIGHT_PX}px`,
            minWidth: `${A4_WIDTH_PX}px`,
            minHeight: `${A4_HEIGHT_PX}px`,
            transform: `scale(${scale})`,
            transformOrigin: "top center",
            boxShadow: "0 1rem 3rem rgba(0,0,0,0.175)",
            flexShrink: 0,
          }}
        >
          <TemplateHeader
            isPdfMode={true}
            headerBg={headerBg}
            showHeaderBg={templateState.showHeaderBg}
            textColorClass={headerTextClass}
            subTextColorClass={headerTextClass}
            isStacked={isStacked}
            isLogoLeft={isLogoLeft}
            logoWrapperClasses={logoWrapperStyles}
            textClasses={textStyles}
            textAlign={textAlign}
            logoSrc={logoSrc}
            logoSize={logoSize}
            showCompanyInfo={templateState.showCompanyInfo}
            headerFields={headerFieldsMap}
          />

          <div
            className="flex-grow-1 d-flex flex-column"
            style={{
              paddingLeft: "3.5rem",
              paddingRight: "3.5rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              color: "#0f172a",
              fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
              fontSize: "12pt",
              lineHeight: "1.6",
              backgroundColor: "#ffffff",
              overflow: "hidden",
              flex: 1,
            }}
          >
            <div
              className="flex-grow-1"
              style={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                wordWrap: "break-word",
                wordBreak: "break-word",
                flex: 1,
              }}
            >
              <div style={{ marginBottom: "1.5rem" }}>
                <p style={{ marginBottom: "1.5rem", color: "#4b5563", fontWeight: "500" }}>[Date]</p>
                <div style={{ marginBottom: "1.5rem" }}>
                  <h4 style={{
                    fontWeight: "bold",
                    fontSize: "13pt",
                    color: "#0f172a",
                    marginBottom: "0.25rem",
                    textTransform: "uppercase",
                    wordWrap: "break-word",
                  }}>
                    RECIPIENT NAME
                  </h4>
                  <div style={{
                    color: "#4b5563",
                    whiteSpace: "pre-line",
                    lineHeight: "1.4",
                    wordWrap: "break-word",
                  }}>
                    Designation<br />Company Name
                  </div>
                </div>
                <p style={{ marginTop: "1rem", color: "#0f172a", fontWeight: "500" }}>Dear [Name],</p>
              </div>

              <div style={{
                textAlign: "justify",
                flex: 1,
                wordWrap: "break-word",
                overflow: "hidden",
              }}>
                <p style={{ marginBottom: "0.5rem" }}>
                  This is a preview of your letterhead template. The logo and company details above will appear on every document created with this template.
                </p>
                <p style={{ marginBottom: "0.5rem" }}>
                  You can adjust the colors, logo size, and alignment using the controls on the left.
                </p>
              </div>

              <div style={{ marginTop: "1.5rem", marginBottom: "1rem", breakInside: "avoid" }}>
                <p style={{ marginBottom: "0.5rem", color: "#0f172a", fontWeight: "500" }}>Sincerely,</p>
                <div style={{ marginTop: "1.5rem" }}>
                  <p style={{
                    fontWeight: "bold",
                    color: "#0f172a",
                    fontSize: "12pt",
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                    marginBottom: 0,
                    wordWrap: "break-word",
                  }}>
                    [YOUR NAME]
                  </p>
                </div>
              </div>
            </div>
          </div>

          <TemplateFooter
            isPdfMode={true}
            footerBg={footerBg}
            footerTextClass={footerTextClass}
            footerText={templateState.footerText}
            showCompanyInfoFooter={templateState.showCompanyInfoFooter}
            footerFields={footerFieldsMap}
            iqCode={templateState.iqCode}
            subject={templateState.subject}
          />
        </div>
      </div>
    </div>
  );
}